import type {
    ArchizeenTileProps,
    ObjectShorthandValue,
} from '@archipro-design/aria';
import { ArchizeenTile } from '@archipro-design/aria';
import { useRef, type ReactNode } from 'react';
import type { LogImpressionProps } from '@archipro-website/tracker';
import { useLogImpression } from '@archipro-website/tracker';
import { useHandleFollow } from '~/modules-rocco/design-board/hook/use-handle-follow';
import { useFollowSelectorProxy } from '~/modules/moodboards/hooks';

export type TileProps = ObjectShorthandValue<ArchizeenTileProps> & {
    impression?: LogImpressionProps;
    articleId?: number;
};

const ArchizeenImpressionTile = (props: TileProps) => {
    const {
        impression,
        professionalID: _,
        articleId,
        children,
        ...rest
    } = props;
    const ref = useRef<HTMLAnchorElement | null>(null);
    const { isInDesignBoard } = useHandleFollow();
    const isFavourited =
        rest.isFavourited ||
        !!(articleId && isInDesignBoard(articleId, 'ArticlePin'));
    const { followSelector, openFollowSelector } = useFollowSelectorProxy({
        pinId: articleId ?? 0,
        pinType: 'ArticlePin',
    });
    useLogImpression({ data: impression, ref });
    return (
        <>
            <ArchizeenTile
                // Polymorphic tile ref (anchor vs div) — Aria’s generated ref type is an impossible intersection
                ref={ref as never}
                {...rest}
                onFavourite={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (!articleId) return;
                    openFollowSelector(e);
                }}
                isFavourited={isFavourited}
            >
                {children as ReactNode}
            </ArchizeenTile>
            {articleId ? followSelector : null}
        </>
    );
};

export default ArchizeenImpressionTile;
